import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  findSqlReportQuery,
  updateSqlReportQuery,
} from 'actions/sqlReportQueries';
import {
  getLoggedInUser,
  getIncludedInGroups,
  getSqlReportQuery,
} from 'reducers';

const withSqlReportQuery = (DecoratedComponent) => {
  class WithSqlReportQuery extends Component {
    state = {
      loading: false,
    };

    componentDidMount() {
      this.fetchReport();
    }

    fetchReport() {
      const {
        findSqlReportQuery,
        match: {
          params: { sqlReportQueryId },
        },
      } = this.props;
      this.setState({ loading: true });
      findSqlReportQuery(sqlReportQueryId).finally(() =>
        this.setState({ loading: false }),
      );
    }

    render() {
      const { children, ...props } = this.props;
      const { loading } = this.state;
      const childProps = {
        loading,
        ...props,
      };
      return React.createElement(DecoratedComponent, childProps, children);
    }
  }

  const mapStateToProps = (
    state,
    {
      match: {
        params: { sqlReportId, sqlReportQueryId },
      },
    },
  ) => {
    const sqlReportQuery = getSqlReportQuery(state, sqlReportQueryId);
    const isAdminOrManager = getIncludedInGroups(state, ['ADMIN', 'MANAGER']);
    const loggedInUser = getLoggedInUser(state);
    return {
      sqlReportId,
      sqlReportQuery,
      isAdminOrManager,
      loggedInUser,
    };
  };

  const mapDispatchToProps = {
    findSqlReportQuery,
    updateSqlReportQuery,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithSqlReportQuery);
};

export default withSqlReportQuery;
